export default __webpack_public_path__ + "static/media/circle-close.e8424ace.svg";